import React from 'react';
import { string } from 'prop-types';
import { Button } from '@thd-olt-component-react/button';

export const QuickViewFooter = ({
  url
}) => {

  const handleBttnClick = (event) => {
    event.preventDefault();
    window.location.href = url;
  };

  return (
    <div className="quickview-details__footer">
      <Button
        onClick={handleBttnClick}
        dark
        outline
        data-testid="quickview-footer-link"
      >View Full Details
      </Button>
    </div>
  );
};

QuickViewFooter.propTypes = {
  url: string.isRequired
};